export class PickupDelivered {

    public rowVersion : string = '';

    constructor(rowVersion : string) {
        this.rowVersion = rowVersion;
    }
}
